import { render, staticRenderFns } from "./RevisarSancionDistrital.vue?vue&type=template&id=6ee11c86&"
import script from "./RevisarSancionDistrital.vue?vue&type=script&lang=js&"
export * from "./RevisarSancionDistrital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports